var _clipPath, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgZzz(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 28,
    viewBox: "0 0 28 28",
    width: 28,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h28v28h-28z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)",
    fill: "#000"
  }, /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m10 25c-3.86599 0-7-3.134-7-7s3.13401-7 7-7c3.866 0 7 3.134 7 7s-3.134 7-7 7zm-9-7c0-4.9706 4.02944-9 9-9 4.9706 0 9 4.0294 9 9s-4.0294 9-9 9c-4.97056 0-9-4.0294-9-9zm9 5c1.1046 0 2-.8954 2-2s-.8954-2-2-2c-1.10457 0-2 .8954-2 2s.89543 2 2 2zm-3-6c1.04001 0 1.89462-.7938 1.99096-1.8086.0092-.0969-.08242-.1685-.17684-.1449-1.19108.2977-2.43716.2977-3.62824 0-.09442-.0236-.18604.048-.17684.1449.09634 1.0148.95095 1.8086 1.99096 1.8086zm7.991-1.8086c-.0964 1.0148-.951 1.8086-1.991 1.8086s-1.8946-.7938-1.991-1.8086c-.0092-.0969.0825-.1685.1769-.1449 1.1911.2977 2.4371.2977 3.6282 0 .0944-.0236.1861.048.1769.1449z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m15.448 10h6.454v-1.652h-3.766l3.542-3.99v-1.344h-6.006v1.652h3.304l-3.528 4.032z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m22.352 7h5.071v-1.298h-2.959l2.783-3.135v-1.056h-4.719v1.298h2.596l-2.772 3.168z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZzz);
export default __webpack_public_path__ + "static/media/zzz.9268049de5cf341bebd890547cf047ca.svg";
export { ForwardRef as ReactComponent };